import {removeSupplierContact} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function removeSupplierContactMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.removeSupplierContact,
    mutationFn: (contactId: number) => removeSupplierContact(supplierId, contactId),
    onSuccess: async (_data, _contactId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
